export default __webpack_public_path__ + "media/calmerCanineMockup.23c29e12.webm";